<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <AccionesContenedoresModalComponent @refresh="refreshData()" />
        <h5 class="form-header">Contenedores</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12 col-12">
              <div class="form-inline justify-content-sm-end">
                <select class="form-control form-control-sm rounded bright" v-model="filtro_estado" @change="filterData">
                  <option value>Todos</option>
                  <option value="CR">CREADO</option>
                  <option value="CA">EN CARGA</option>
                  <option value="PS">POR SALIR</option>
                  <option value="ED">EN DESTINO</option>
                  <option value="ER">EN RUTA</option>
                  <option value="RE">RETORNADO</option>
                </select>
                <select class="form-control form-control-sm rounded bright" v-model="filtro_ruta" @change="filterData"
                  style="width: 150px">
                  <option value>Rutas</option>
                  <option v-for="data in rutas" :value="data.id" v-bind:key="data.id">
                    {{ data.tienda_origen }} ---> {{ data.tienda_destino }}
                  </option>
                </select>
                <input class="form-control form-control-sm rounded bright" placeholder="Search" v-model="searchtext"
                  type="text" v-on:keyup.enter="filterData" />
                <button class="btn btn-link btn-sm" type="button" v-on:click="filterData">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                  <i class="fa fa-times"></i>
                </button>
                <div class="input-group-append"></div>
              </div>
            </div>
          </div>
          <br>
          <div class="col-sm-12">
            <NuevoContenedorModalComponent />
          </div>
        </div>
      </div>
      <ContenedorTableComponent :datatabla="data" />
      <PaginationComponent :currentPage="currentPage" :data="data" tipo="MINI" @pagechanged="onPageChange" />
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ContenedorService from "@/services/wms/ContenedorService";
import NuevoContenedorModalComponent from "@/components/wms/contenedor/NuevoContenedorModalComponent";
import ContenedorTableComponent from "@/components/wms/contenedor/ContenedorTableComponent";
import AccionesContenedoresModalComponent from "@/components/wms/contenedor/AccionesContenedoresModalComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
    NuevoContenedorModalComponent,
    ContenedorTableComponent,
    AccionesContenedoresModalComponent,
  },
  data() {
    return {
      filtro_ruta: [],
      current: [],
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: null,
      filterActiva: "",
      data: [],
      rutas: [],
      filtro_estado: "",
    };
  },
  mounted() {
    this.refreshData();
    this.refreshRutas();
  },
  methods: {
    refreshRutas() {
      let self = this;
      DynamicService.fetch("wms", "rutas").then((response) => {
        self.rutas = response.data.results;
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        ruta: this.filtro_ruta,
        "filter[search]": this.searchtext,
        activa: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        ruta: this.filtro_ruta,
        estado: this.filtro_estado,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.filtro_ruta = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActiva,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      ContenedorService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-contenedor-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-contenedor-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() { },
  },
};
</script>
